export const LanguageCode = {
  NORWEGIAN: 'nb',
  SWEDISH: 'se',
  ENGLISH: 'en'
} as const;

export type LanguageCodeType = (typeof LanguageCode)[keyof typeof LanguageCode];
